import React from "react";
import {LogoDiscoverIcon} from "../../../../../../../assets/svg/logo-discover.icon";
import {CardNetworkModel} from "./card-network.model";
import {CardNetworksEnum} from "../../payment-method-codes.enum";
import {ICardNetworkIconOptions} from "./card-network.view-model.interface";

export class DiscoverCardNetworkModel extends CardNetworkModel {
    constructor() {
        super(CardNetworksEnum.Discover);
    }
    get name(): string {
        return "Discover";
    }

    renderIcon(options?: ICardNetworkIconOptions): React.ReactElement | null {
        return (<LogoDiscoverIcon {...options}/>);
    }
}